<template src="./YourPublishedOffers.html">

</template>

<script>

import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";
import ArrobaMedellinSeeker from "@/components/ArrobaMedellinSeeker/ArrobaMedellinSeeker";
const {DateTime} = require("luxon");

export default {
  name: "YourPublishedOffers",
  props: {
    offers: {
      type: Array
    },
    remarkableOffers: {
      type: Array,
      default: () => []
    },
    errorMessage: {
      type: Boolean
    }
  },
  components:{
    ArrobaMedellinArrobitaNoData,
    ArrobaMedellinSeeker
  },
  filters:{
    dateFormat: function (value){
      return DateTime.fromISO(value).toFormat('dd LLLL yyyy ', { locale: "es" })
    }
  },
  computed: {
    activeOffersCount() {
      return this.offers.filter((offer) => !offer.isClosed && !offer.isFinished).length;
    },
    totalApplicants() {
      return this.remarkableOffers.reduce((total, offer) => total + (offer.numParticipants || 0), 0);
    },
    topOfferName() {
      if (!this.remarkableOffers.length) return "—";
      const top = this.remarkableOffers.reduce((max, offer) =>
        (offer.numParticipants || 0) > (max.numParticipants || 0) ? offer : max
      );
      return top.name;
    },
    expiringOffersCount() {
      const now = DateTime.local();
      const limit = now.plus({ days: 7 });
      return this.offers.filter((offer) => {
        if (offer.isClosed || offer.isFinished || !offer.deadline) return false;
        const deadline = DateTime.fromISO(offer.deadline);
        return deadline >= now && deadline <= limit;
      }).length;
    },
    enrichedOffers() {
      const now = DateTime.local();
      return this.offers.map((offer) => {
        const isExpired = offer.deadline ? DateTime.fromISO(offer.deadline) < now : false;
        const isInactive = offer.isClosed || offer.isFinished;
        let statusLabel = "Activa";
        let statusClass = "status-pill--active";
        if (isInactive) {
          if (isExpired) {
            statusLabel = "Vencida";
            statusClass = "status-pill--expired";
          } else {
            statusLabel = "Cerrada";
            statusClass = "status-pill--closed";
          }
        }
        return {
          ...offer,
          _isExpired: isExpired,
          _statusLabel: statusLabel,
          _statusClass: statusClass
        };
      });
    }
  }
}
</script>

<style scoped lang="scss" src="./YourPublishedOffers.scss">

</style>
